function FileUploader({ file, setFile }) {
  const handleFileSelect = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <div className='bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8 rounded-md'>
      <div className='sm:mx-auto sm:w-full sm:max-w-md'>
        <div className='bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10'>
          <form className='space-y-6'>
            <div>
              <label
                htmlFor='file'
                className='block text-sm font-medium text-gray-700'
              >
                Select a file to upload
              </label>
              <div className='mt-1'>
                <input
                  id='file'
                  name='file'
                  type='file'
                  accept='application/pdf'
                  className='focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300'
                  onChange={handleFileSelect}
                />
              </div>
            </div>

            <div>
              {file && (
                <div>
                  <p className='text-sm text-gray-500'>Selected file:</p>
                  <p className='mt-1 font-semibold text-gray-900 break-words'>
                    {file.name}
                  </p>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FileUploader;
